import React from 'react';
import { useLocation } from 'react-router-dom';
import { Paper, type PaperProps, Container, Stack, styled } from '@mui/material';
import { isProduction, drawerWidth } from '../../constants';
import { useAppSelector } from '../../store/hooks';
import { selectUi } from '../../store/slices/ui';
import { CompactFooter } from './CompactFooter';
import { FullFooter } from './FullFooter';
import { RouterUrl } from 'routes';
import { RouterLinkStyled } from './style/general';

const FooterPaper = styled(Paper, {
  shouldForwardProp: prop => prop !== 'withDrawer',
})<{ withDrawer: boolean }>(({ theme, withDrawer }) => ({
  backgroundColor: theme.palette.common.white,
  maxWidth: '100%',
  marginLeft: 0,
  width: '100%',
  borderColor: '#EEEFF4',
  paddingBlock: '30px',
  borderLeft: 'inherit',
  ...(withDrawer && {
    [theme.breakpoints.up('sm')]: {
      maxWidth: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      borderLeft: 0,
    },
  }),
  [theme.breakpoints.up('md')]: {
    paddingBlock: '40px',
  },
})) as React.ComponentType<PaperProps<'footer', { withDrawer: boolean }>>;

const FooterContainer = styled(Container)(() => ({
  height: '100%',
}));

export const Footer = () => {
  const { pathname } = useLocation();
  const accountPath = pathname.includes('account');
  const reclamationPath = pathname.includes('reclamation');
  const { isFooterHidden } = useAppSelector(selectUi);

  return (
    <>
      {isFooterHidden ? null : (
        <FooterPaper withDrawer={accountPath} component="footer" square variant="outlined">
          <FooterContainer>
            {accountPath || reclamationPath ? <FullFooter /> : <CompactFooter />}
            {!isProduction && (
              <Stack gap="10px" flexDirection="row" marginTop={2} flexWrap={'wrap'}>
                <RouterLinkStyled to="/user">User</RouterLinkStyled>
                <RouterLinkStyled to={RouterUrl.Account}>Account</RouterLinkStyled>
                <RouterLinkStyled to={RouterUrl.Login}>Login</RouterLinkStyled>
                <RouterLinkStyled to={RouterUrl.Registration}>Registration</RouterLinkStyled>
                <RouterLinkStyled to={RouterUrl.CreateApplicationPage}>Create 1st application</RouterLinkStyled>
                <RouterLinkStyled to={RouterUrl.ApplicationConsideration}>Application consideration</RouterLinkStyled>
                <RouterLinkStyled to={RouterUrl.SigningAgreement}>Signing agreement</RouterLinkStyled>
                <RouterLinkStyled to={RouterUrl.SigningExtensionAgreement}>
                  Signing extension agreement
                </RouterLinkStyled>
              </Stack>
            )}
          </FooterContainer>
        </FooterPaper>
      )}
    </>
  );
};
